export default "/site/aidive/js/react/dist/images/warning-3d.07ca73f0.png";